import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_WALKDOWN_ID = 'walkdownId'

export const walkdownDetailsSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
  [SEARCH_PARAM_WALKDOWN_ID]: z.string().catch(''),
})

export const createWalkdownsSearch = (siteId: string | undefined) => ({
  [SEARCH_PARAM_SITE_ID]: siteId || undefined,
})

export type WalkdownDetailsSearch = z.infer<typeof walkdownDetailsSearchParams>

export const createWalkdownDetailsSearch = ({
  siteId,
  walkdownId,
}: WalkdownDetailsSearch) => ({
  [SEARCH_PARAM_SITE_ID]: siteId,
  [SEARCH_PARAM_WALKDOWN_ID]: walkdownId,
})
